<dx-toolbar class="report-toolbar">
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row items-center">
        <span class="block mr-2 text-sm font-medium">Filter: </span>
        <dx-select-box
          stylingMode="underlined"
          width="140"
          displayExpr="label"
          valueExpr="value"
          placeholder="Filter"
          [value]="currentFilter"
          (onValueChanged)="dateFilterChanged($event)"
          [items]="dateFilters">
        </dx-select-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex ml-4 mr-4 flex-row items-center">
        <span class="block mr-2 text-sm font-medium">Date début: </span>
        <dx-date-box
          stylingMode="underlined"
          (onValueChanged)="dateChanged($event)"
          [(value)]="request.from">
        </dx-date-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex ml-4 mr-4 flex-row items-center">
        <span class="block mr-2 text-sm font-medium">Date fin: </span>
        <dx-date-box
          stylingMode="underlined"
          (onValueChanged)="dateChanged($event)"
          [(min)]="request.from"
          [(value)]="request.to">
        </dx-date-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="auto"
            [options]="generateButtonOptions">
  </dxi-item>

  <dxi-item location="after"
            widget="dxButton"
            locateInMenu="auto"
            [options]="exportButtonOptions">
  </dxi-item>
</dx-toolbar>

